import { mqttLogger } from '@hooks/mqtt/utils';
import { Setter, WritableAtom } from 'jotai';
import { logSubscriptionEvent, SubscriptionEvent } from './atomUtils';

interface ScheduleUnsubscribeAtomParams {
  topic: string;
  subscriberId: string;
  force?: boolean;
}

export function isValidSubscriber(
  subscribersSet: Set<string>,
  subscriberId: string,
): boolean {
  return subscribersSet.has(subscriberId);
}

export function isLastSubscriber(subscribersSet: Set<string>): boolean {
  return subscribersSet.size === 1;
}

export function hasSubscriber(
  currentSubscribers: Set<string>,
  subscriberId: string,
  topic: string,
): boolean {
  if (!currentSubscribers.has(subscriberId)) {
    mqttLogger.debug(`Subscriber ${subscriberId} not found for topic ${topic}`);
    return false;
  }
  return true;
}

export function logSubscriberRemoval(
  topic: string,
  subscriberId: string,
  remainingSubscriberCount: number,
): void {
  logSubscriptionEvent(SubscriptionEvent.RemoveSubscriber, topic, {
    subscriberId,
    subscriberCount: remainingSubscriberCount,
  });
}

export function scheduleUnsubscribe(
  set: Setter,
  scheduleDebouncedUnsubscribeAtom: WritableAtom<
    null,
    [ScheduleUnsubscribeAtomParams],
    Promise<void>
  >,
  topic: string,
  subscriberId: string,
  immediate: boolean,
): void {
  if (immediate) {
    mqttLogger.debug(
      `Immediate unsubscribe requested for ${topic} (subscriber: ${subscriberId})`,
    );
    set(scheduleDebouncedUnsubscribeAtom, {
      topic,
      subscriberId,
      force: true,
    });
  } else {
    set(scheduleDebouncedUnsubscribeAtom, {
      topic,
      subscriberId,
    });
  }
}
